import {
  CABINET_SHELL_OWNS_BACK,
  CABINET_SHELL_OWNS_TITLE,
  CabinetShellChromeService,
} from '@nebalkon-workspace/cabinet-client';

export const MOBILE_STAFF_CABINET_SHELL_PROVIDERS = [
  CabinetShellChromeService,
  { provide: CABINET_SHELL_OWNS_BACK, useValue: true },
  { provide: CABINET_SHELL_OWNS_TITLE, useValue: true },
] as const;
